import script from "./JaContentFrameCell.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContentFrameCell.vue?vue&type=script&setup=true&lang=js"

import "./JaContentFrameCell.vue?vue&type=style&index=0&id=22e47ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22e47ffc"]])

export default __exports__